<template>
    <div class="user-manage">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-content">
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="user-content">
            <div class="tree-list">
                <el-tree
                    :data="treeList"
                    show-checkbox
                    node-key="groupId"
                    ref="tree"
                    ighlight-current
                    default-expand-all
                    @check-change="checkChange"
                    :props="defaultProps">
                </el-tree>
            </div>
            <div class="content-right">
                <el-card class="box-card">
                    <el-form label-width="80px" :inline="true" :model="params" class="demo-form-inline">
                        <el-form-item label="系统">
                            <el-select size="small" filterable v-model="params.companyId" placeholder="请选择系统" clearable>
                                <el-option
                                    v-for="item in companyOptions"
                                    :key="item.companyId"
                                    :label="item.companyName"
                                    :value="item.companyId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item size="small" label="用户名称">
                            <el-input v-model="params.userName" placeholder="请输入用户名称"></el-input>
                        </el-form-item>
                        <el-form-item size="small" label="默认部门">
                            <el-input size="small" v-model="params.defaultPositionName" placeholder="请输入默认部门"></el-input>
                        </el-form-item>
                        <el-form-item size="small" label="用户状态">
                            <el-select v-model="params.userStatus" placeholder="请选择用户状态">
                                <el-option label="全部" :value="-1"></el-option>
                                <el-option label="启用" :value="0"></el-option>
                                <el-option label="禁用" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="btn" style="margin-left: 20px">
                        <el-form>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="searchUser">查 询</el-button>
                            <el-button size="mini" icon="el-icon-edit" type="primary" @click="toAddUserPage">新 增</el-button>
                            <el-button size="mini" icon="el-icon-document-copy" type="primary" @click="copyUserInfo">复 制</el-button>
                            <!-- <el-button size="mini" icon="el-icon-mobile" type="primary" @click="associationBatch()">关联系统</el-button> -->
                        </el-form>
                    </div>
                </el-card>
                <el-card class="box-card" style="margin-top: 10px; padding-bottom: 20px; overflow: hidden;">
                    <el-table
                        ref="multipleTable"
                        v-loading="loading"
                        :data="tableData"
                        :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                            label="序号"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="realName"
                            label="用户名称"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="defaultPositionName"
                            label="默认部门"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="userEmail"
                            align="center"
                            label="邮箱">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            align="center"
                            label="用户状态"
                        >
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.userStatus"
                                    :disabled="scope.row.workingStatus == 1"
                                    active-value="0"
                                    inactive-value="1"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    @change="updateStatus($event, scope.row, scope.$index)"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="工作状态"
                        >
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.workingStatus"
                                    :disabled="scope.row.workingStatus == 1"
                                    active-value="0"
                                    inactive-value="1"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    @change="changeWorkStatus($event, scope.row, scope.$index)"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" >
                            <template slot-scope="scope">
                                {{ scope.row.createdTime | moment }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-dropdown>
                                    <el-button size="mini" type="primary">
                                        更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="deleteUserInfo(scope.row.userId)">删除</el-dropdown-item>
                                        <el-dropdown-item @click.native="toEditUserPage(scope.row)">编辑</el-dropdown-item>
                                        <el-dropdown-item @click.native="permissionsConfig(scope.row)">权限配置</el-dropdown-item>
                                        <!-- <el-dropdown-item @click.native="relationSystem(scope.row)">关联系统</el-dropdown-item> -->
                                        <el-dropdown-item @click.native="assignmentRole(scope.row)">分配角色</el-dropdown-item>
                                        <el-dropdown-item @click.native="resetPassword(scope.row)">重置密码</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        class="pagination"
                        background
                        @size-change="handleSizeChange"
                        @current-change="changePage"
                        :current-page="params.pageNo"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </el-card>
            </div>
        </div>
        <!-- 导入用户 -->
        <el-dialog
            title="导入"
            :visible.sync="importVisible"
            width="30%"
            top="5vh"
            :before-close="handleClose"
        >
            <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="importVisible = false">取 消</el-button>
                <el-button type="primary" @click="importVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 重置密码 -->
        <el-dialog
            title="密码重置"
            :visible.sync="resetVisible"
            width="40%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="resetForm" :rules="rules" ref="resetForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="用户名称" prop="userName">
                    <el-input v-model="resetForm.userName" disabled></el-input>
                </el-form-item>
                <el-form-item label="登陆密码" prop="passWord">
                    <el-input type="password" v-model="resetForm.passWord"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetVisible = false">取 消</el-button>
                <el-button type="primary" @click="determineReset('resetForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 关联系统 -->
        <el-dialog
            title="关联系统"
            :visible.sync="relationVisible"
            width="40%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="relationParams" :rules="rules" ref="relationParams" label-width="80px"
                     class="demo-ruleForm">
                <el-form-item label="系统" prop="companyId">
                    <el-select size="small" style="width: 100%;" filterable v-model="relationParams.companyId"
                               placeholder="请选择系统" clearable>
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位" prop="positionNo">
                    <el-select
                        size="small"
                        clearable
                        v-model="relationParams.positionNo"
                        placeholder="请选择岗位"
                        @focus="getAllPostInfo"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in postList"
                            :key="item.positionId"
                            :label="item.positionName"
                            :value="item.positionId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门" prop="departNo" placeholder="请选择部门">
                    <el-tree
                        :data="relationDepartList"
                        show-checkbox
                        node-key="groupId"
                        ref="tree"
                        highlight-current
                        check-strictly
                        @check-change="selectDepart"
                        :props="defaultProps">
                    </el-tree>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="relationVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRelationDepart('relationParams')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量关联系统 -->
        <el-dialog
            title="关联系统"
            :visible.sync="relationSystemVisible"
            width="40%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="relationParams" :rules="rules" ref="relationParams" label-width="80px"
                     class="demo-ruleForm">
                <el-form-item label="系统" prop="companyId">
                    <el-select size="small" style="width: 100%;" filterable v-model="relationParams.companyId"
                               placeholder="请选择系统" clearable multiple @change="selectChange">
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位" prop="positionNo">
                    <el-select
                        size="small"
                        clearable
                        multiple
                        filterable
                        v-model="relationParams.positionNo"
                        placeholder="请选择岗位"
                        @focus="getAllPostList"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in mulSelectPost"
                            :key="item.positionId"
                            :label="item.positionName"
                            :value="item.positionId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门" prop="departNo">
                    <el-select size="small" style="width: 100%;" filterable v-model="relationParams.departNo"
                               placeholder="请选择部门" clearable multiple @focus="getAllGroupList">
                        <el-option
                            v-for="item in mulSelectGroup"
                            :key="item.groupId"
                            :label="item.groupName"
                            :value="item.groupId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="relationSystemVisible = false">取 消</el-button>
                <el-button type="primary" @click="mulRelationSystem('relationParams')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 复制用户信息 -->
        <el-dialog
            title="复 制"
            :visible.sync="copyVisible"
            width="50%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="copyRuleForm" :rules="rules" ref="copyRuleForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="源用户" prop="userCode">
                    <el-select 
                        size="small" 
                        style="width: 100%;" 
                        v-model="copyRuleForm.userCode"    
                        placeholder="请选择源用户" 
                        clearable 
                        filterable>
                        <el-option
                            v-for="item in userAllList"
                            :key="item.userId"
                            :label="item.realName"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标用户" prop="userCodes">
                    <el-transfer
                        v-model="value"
                        :titles="['未选择', '已选择']"
                        :props="{ key: 'userId', label: 'userName' }"
                        @change="handleTargetUser"
                        :data="userAllList">
                    </el-transfer>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopy('copyRuleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getUserData,
    deleteUserMange,
    updateUserStatus,
    resetUserPassword,
    getDepartInfo,
    updateHandOverStatus,
    getPostInfo,
    userRelationSystem,
    findByPostItem,
    findDepartItemInfo,
    findUserInfo,
    copyJurisdiction
} from '@/api/usermange';
import { getDepartInfoList,getDepartInfoLists} from '@/api/departMange';
import { getSystemData } from "@/api/systemMange";
import { hasBtnPermission } from '@/utils';

export default {
    name: "UserManage",
    data() {
        return {
            relationSystemVisible: false,
            relationVisible: false,
            importVisible: false,
            resetVisible: false,
            copyVisible: false,
            loading: false,
            filterText: '',
            // 部门结构树形列表
            treeList: [],
            defaultProps: {
                children: 'children',
                label: 'groupName'
            },
            // 表格数据
            tableData: [],
            // 选择数据列表
            multipleSelection: [],
            totalCount: null,
            // 请求参数
            params: {
                pageNo: 1,
                pageSize: 10,
                companyId: 1,
                groupIds: null,
                userCode: null,
                userStatus: null,
                defaultPositionName: '', // 默认部门
                userName: '', // 用户名称
            },
            companyOptions: [],
            groupOptions: [],
            // 重置密码
            resetForm: {
                passWord: '123456',
                userId: '',
                userName: ''
            },
            rules: {
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'}
                ],
                userName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                companyId: [
                    {required: true, message: '请选择系统', trigger: ['change', 'blur']}
                ],
                positionNo: [
                    {required: true, message: '请选择岗位', trigger: ['change', 'blur']}
                ],
                departNo: [
                    {required: true, message: '请选择部门', trigger: 'change'}
                ],
                userCode: [
                    { required: true, message: '请选择原用户', trigger: ['change', 'blur'] }
                ],
                userCodes: [
                    { required: true, message: '请选择目标用户', trigger: ['change', 'blur'] }
                ]
            },
            i: 0,
            relationParams: {
                companyId: '', // 系统ID
                departNo: '', // 部门ID
                positionNo: '', // 岗位ID
                userCode: '', // 登陆用户ID
                userId: '', // 用户ID
            },
            postList: [],
            relationDepartList: [],
            // relationTreetList: [],
            batchRelationParams: {
                systemId: [],
                userCode: '',
                selectUserList: []
            },
            mulSelectPost: [],
            mulSelectGroup: [],
            // 复制
            value: [],
            copyRuleForm: {
                userCode: '',
                userCodes: ''
            },
            // 所有用户列表
            userAllList: [],
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        "relationParams.companyId"(newVal, oldVal) {
            if (newVal) {
                this.getDepartTreeList()
            }
        },
        "params.companyId"(newVal, oldVal){
            if(newVal) {
                this.getDepartTreeData()
            }
        }
    },
    // computed: {
    //     relationDepartList(){
    //         this.getDepartTreeList()
    //     }
    // },
    created() {
        this.getAllSystemInfo()
        this.getUserList()
        this.getDepartTreeData()
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo() {
            let searchSystemParams = {
                pageNo: 1,
                pageSize: 100,
                companyName: '',
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
            }
            const res = await getSystemData(searchSystemParams);
            if (res.code === '200') {
                this.companyOptions = res.data.list
            } else {
                this.$message.error(res.msg)
            }
        },
        async getDepartTreeData(){
            let params = {
                companyId: this.params.companyId,
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
            }
            const res = await getDepartInfoLists(params);
            if(res.code === '200'){
                this.treeList = res.data
            }else{
                this.$message.error(res.msg)
            }
        },
        // 关联系统查询部门
        async getDepartTreeList() {
            this.relationParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
            const res = await getDepartInfoLists(this.relationParams)
            if (res.code === '200') {
                this.relationDepartList = res.data
                this.relationTreetList = res.data
            } else {
                this.$message.error(res.msg)
                this.tableData = []
            }
        },
        // 查询所有岗位
        async getAllPostInfo() {
            if (!this.relationParams.companyId) {
                this.$message.warning('请先选择系统')
                return
            }
            let params = {
                companyId: this.relationParams.companyId,
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
            }
            const res = await getPostInfo(params);
            if (res.code === '200') {
                this.postList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        // 分页查询用户信息
        async getUserList() {
            this.loading = true
            this.params.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
            const res = await getUserData(this.params);
            if (res.code === '200') {
                res.data.list.forEach(item => {
                    item.userStatus = String(item.userStatus)
                    item.workingStatus = String(item.workingStatus)
                })
                this.$nextTick(() => {
                    this.tableData = res.data.list
                })
                this.totalCount = res.data.total
            }
            this.loading = false
        },
        searchUser() {
            this.treeList = []
            if (!hasBtnPermission('sys:user:list')) {
                this.$message.warning('您暂无权限操作')
                return
            }
            this.getUserList()
            this.getDepartTreeData()
        },
        // 更新用户状态
        async updateStatus(b, item, index) {
            this.tableData[index].userStatus = item.userStatus === '0' ? '1' : '0'
            const status = item.userStatus;
            let params = {
                userId: item.userId,
                userStatus: item.userStatus === '0' ? '1' : '0'
            }
            const res = await updateUserStatus(params);
            if (res.code === '200') {
                status === '1' ? this.$message.success('禁用成功') : this.$message.success('启用成功')
            } else {
                this.tableData[index].userStatus = item.userStatus === '0' ? '1' : '0'
                this.$message.error(res.msg)
            }
            this.getUserList()
        },
        // 改变用户工作状态
        async changeWorkStatus(b, item, index) {
            this.tableData[index].workingStatus = item.workingStatus === '0' ? '1' : '0'
            this.$confirm('确认修改该用户的在职状态吗?', '提示', {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                this.confirmChangeWorkStatus(b, item, index)
            }).catch(_ => {
                this.tableData[index].workingStatus = item.workingStatus === '0' ? '1' : '0'
                this.$message.error(res.msg)
            })
        },
        async confirmChangeWorkStatus(b, item, index){
            let params = {
                userId: item.userId,
                workingStatus: item.workingStatus === '0' ? '1' : '0',
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await updateHandOverStatus(params);
            if (res.code === '200') {
                this.$message.success('修改成功')
            } else {
                this.tableData[index].workingStatus = item.workingStatus === '0' ? '1' : '0'
            }
            this.getUserList()
        },
        // 权限配置
        permissionsConfig(item){
            this.$router.push({
                name: 'PermissionConfig',
                query: {
                    id: item.userId
                }
            })
        },
        // 删除用户
        deleteUserInfo(userId) {
            if (!hasBtnPermission('sys:user:delete')) {
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$confirm('确认删除该数据吗？', '提示')
                .then(_ => {
                    this.confirmDelete(userId)
                })
                .catch(_ => {
                })
        },
        // 确认删除
        async confirmDelete(userId) {
            const res = await deleteUserMange(userId);
            if (res.code === '200') {
                this.$message.success('删除成功')
            } else {
                this.$message.error(res.msg)
            }
        },
        // 重置密码
        resetPassword(item) {
            this.resetVisible = true
            this.resetForm.userName = item.userName
            this.resetForm.userId = item.userId
        },
        // 重置密码
        determineReset(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmResetPassword()
                } else {
                    return false;
                }
            });
        },
        async confirmResetPassword() {
            const res = await resetUserPassword(this.resetForm);
            if (res.code === '200') {
                this.$message.success('密码重置成功')
                this.resetVisible = false
            } else {
                this.$message.error(res.msg)
            }
        },
        // 部门选择
        checkChange(data, checked, node) {
            this.params.groupIds = this.$refs.tree.getCheckedKeys().toString();
        },
        // 关联系统，系统单选
        selectDepart(data, checked, node) {
            this.i++;
            if (this.i % 2 === 0) {
                if (checked) {
                    this.$refs.tree.setCheckedNodes([]);
                    this.$refs.tree.setCheckedNodes([data]);
                } else {
                    this.$refs.tree.setCheckedNodes([]);
                }
            }
            // 将获取的值赋值给输入框
            let res = this.$refs.tree.getCheckedNodes()
            let arr = []
            res.forEach((item) => {
                arr.push(item.groupId)
            })
            this.relationParams.departNo = arr
            this.params.groupIds = this.$refs.tree.getCheckedKeys().toString();
        },
        // 确认关联系统部门岗位
        addRelationDepart(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmRelationDepart()
                } else {
                    return false;
                }
            });
        },
        async confirmRelationDepart() {
            this.relationParams.departNo = this.relationParams.departNo.toString()
            const res = await userRelationSystem(this.relationParams);
            if (res.code === '200') {
                this.$message.success('关联成功')
                this.relationVisible = false
            } else {
                this.$message.error(res.msg)
            }
        },
        // 关联系统
        relationSystem(item) {
            this.relationParams.userId = item.userId.toString()
            this.relationParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
            this.relationVisible = true
        },
        // 批量关联
        associationBatch(){
            if(this.multipleSelection.length === 0){
                this.$message.warning('请选择用户');
                return
            }else{
                this.multipleSelection.forEach((item,index) => {
                    this.batchRelationParams.selectUserList.push(item.userId)
                })
            }
            this.relationSystemVisible = true;
        },
        // 批量关联选择用户
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 批量关联系统选择
        async selectChange(e){
            this.batchRelationParams.systemId = e;
        },
        // 获取所有岗位信息
        async getAllPostList(){
            if(this.batchRelationParams.systemId.length === 0){
                this.$message.warning('请先选择系统')
                return
            };
            let params = {
                companyIds: this.batchRelationParams.systemId.toString(),
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await findByPostItem(params);
            if(res.code === '200'){
                this.mulSelectPost = res.data
            }else{
                this.$message.error(res.msg)
            }
        },
        // 批量关联获取所有部门信息
        async getAllGroupList(){
            let params = {
                companyIds: this.batchRelationParams.systemId.toString(),
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await findDepartItemInfo(params);
            if(res.code === '200'){
                this.mulSelectGroup = res.data
            }else{
                this.$message.error(res.msg)
            }
        },
        // 批量关联系统确定事件
        mulRelationSystem(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmAddSystem()
                } else {
                    return false;
                }
            });
        },
        // 确认关联事件
        async confirmAddSystem(){
            let param = {
                departNo: this.relationParams.departNo.toString(),
                positionNo: this.relationParams.positionNo.toString(),
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
                userId: this.batchRelationParams.selectUserList.toString()
            }
            const res = await userRelationSystem(param);
            if(res.code === '200'){
                this.$message.success('关联成功')
                this.relationSystemVisible = false
            }else{
                this.$message.error(res.msg)
            }
        },
        // 进入新增用户
        toAddUserPage(e, item) {
            if (!hasBtnPermission('sys:user:save')) {
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$router.push({
                path: '/sys/addUser',
            })
        },
        // 进入修改用户信息页面
        toEditUserPage(item){
            if (!hasBtnPermission('sys:user:save')) {
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$router.push({
                path: '/sys/editUser',
                query: {
                    userInfo: JSON.stringify(item)
                }
            })
        },
        // 进入角色分配页面
        assignmentRole(item) {
            if(!this.params.companyId){
                this.$message.warning('请选择系统')
                return
            }
            this.$router.push({
                path: '/userMange/userAssignRole',
                query: {
                    id: item.userId,
                    name: item.userName,
                    companyId: this.params.companyId
                }
            })
        },
        // 修改页码
        changePage(e) {
            this.params.pageNo = e;
            this.getUserList()
        },
        handleSizeChange(e){
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getUserList()
        },
        // dialog关闭
        handleClose() {
            this.importVisible = false
            this.resetVisible = false
            this.relationVisible = false
            this.copyVisible = false
        },
        // 复制用户信息
        copyUserInfo(){
            this.copyVisible = true
            this.getPageUserInfo()
        },
        handleTargetUser(val){
            this.copyRuleForm.userCodes = val
        },
        async getPageUserInfo(){
            const res = await findUserInfo();
            if(res.code === '200'){
                this.userAllList = res.data
            }else{
                this.$message.error(res.msg)
            }
            this.userAllList = res.data
        },
        async confirmCopy(){
            const res = await copyJurisdiction(this.copyRuleForm);
            if(res.code === '200'){
                this.$message.success('复制成功')
                this.copyVisible = false
            }else{
                this.$message.error(res.msg)
            }
        },
    },
}
</script>
<style scoped>
::v-deep .el-table::before {
    height: 0;
}

::v-deep .el-card__body {
    padding: 20px 20px 0 20px;
}
::v-deep .captcha-img.el-switch.is-disabled {
    opacity: 1;
}
::v-deep .el-switch__core {
    cursor: pointer;
}
::v-deep .pagination{
    margin: 20px 0 0;
}

</style>
<style scoped lang="scss">
.user-manage {
    height: 100%;

    .breadcrumb-content {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: white;
        border-radius: 4px;
        margin-bottom: 10px;
        text-indent: 10px;
    }

    .user-content {
        //display: flex;
        //justify-content: space-between;
        position: relative;
        height: 100vh;

        .tree-list {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 290px;
            height: 100%;

            .el-tree {
                width: 100%;
                height: 100%;
            }
        }

        .content-right {
            position: absolute;
            left: 290px;
            right: 0;
            margin-left: 10px;

            .btn {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                .pagination {
                    text-align: right;
                    margin: 20px 0 0;
                }
            }
        }
    }
}
</style>
